export enum PreRenderType {
  raster = <any>'raster',
  vector = <any>'vector',
  scaledRaster = <any>'scaledRaster',
  combined = <any>'combined',
  scaledCombined = <any>'scaledCombined'
}
